import type { NextPage } from "next";
import { useTranslation } from "next-i18next/pages";
import ContactForm from "components/contact/ContactForm";
import ContactNextStep from "components/contact/ContactNextStep";
import SubpageShell from "components/common/SubpageShell";
import {
  CMS_REVALIDATE_SECONDS,
  serverSideCmsTranslations
} from "lib/cms/translations";
import styles from "../../styles/contact/Contact.module.css";

export async function getStaticProps({ locale }: any) {
  return {
    props: {
      ...(await serverSideCmsTranslations(locale, ["common", "contact"]))
    },
    revalidate: CMS_REVALIDATE_SECONDS
  };
}

const ContactPage: NextPage = () => {
  const { t } = useTranslation("contact");

  return (
    <SubpageShell
      title={t("global.websiteTitle")}
      description={t("global.websiteDescription")}
      path="/contact"
      heading=""
      subtitle=""
      hideHero
      hideFooterCta
    >
      <section className={styles.hero} aria-labelledby="contact-title">
        <div className={styles.heroInner}>
          <div className={styles.intro}>
            <p className={styles.eyebrow}>{t("hero.eyebrow")}</p>
            <h1 id="contact-title" className={styles.title}>
              {t("hero.title")}
            </h1>
            <p className={styles.description}>{t("hero.description")}</p>
            <div className={styles.introActions}>
              <a className={styles.primaryLink} href="#contact-form">
                {t("hero.formCta")} <span aria-hidden="true">↓</span>
              </a>
            </div>
          </div>

          <div className={styles.formStage}>
            <div className={styles.imageField} aria-hidden="true" />
            <ContactForm />
          </div>
        </div>
      </section>

      <ContactNextStep />
    </SubpageShell>
  );
};

export default ContactPage;
